import React, { useEffect } from 'react';
import { updateHeaderColor } from '../../utils/scroll';

import S from './Support.module.css';

const BuySucsPage = () => {

  useEffect(() => {
    const wheelHandler = (e) => {
      updateHeaderColor();
    };

    window.addEventListener('scroll', wheelHandler);

    return () => {
      window.removeEventListener('scroll', wheelHandler);
    };
  }, []);

  const handleClose = () => {
    if (window.opener) {
      window.opener.location.href = '/support/buy';
    }
    window.close();
  };

  return (
    <div className='sideBannerComp flex-coulum'>
      <div className='com-content-wrap mt-200 mb-50'>
        <div className={`flex-column w-70 ${S.pwdDiv}`} draggable>
            <div className={S.pwdTitle}>
              결제가 <span className='rf-font'>완료</span> 되었습니다.
            </div>
            <div className={`mt-30 mb-80 ${S.buyBtn}`} onClick={handleClose}>닫기</div>
        </div>
      </div>
    </div>
  );
};

export default BuySucsPage;
